module.exports = __webpack_public_path__ + "static/media/Ellipse_1.8c744e49.png";